module.exports = __webpack_public_path__ + "img/new_workwear.5b1eb7b3.jpg";